import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { BankOpeningBalancesModel } from "../models/BankOpeningBalancesModel";
import { BankOpeningBalancesDto } from "../dtos/BankOpeningBalancesDto";
import { NewDocumentModalViewContext } from "src/components/Shared/NewDocumentModalView";
import handleFormSubmit, { DocumentSaveActionType } from "src/helpers/DocumentHelper";
import { AppEntities } from "src/config/entities";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFSecondTab } from "src/components/Shared/NewForms/NFSecondTab";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "src/components/Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "src/components/Shared/DetailViews/DetailViewToolbarMoreActions";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { BankOpeningBalancesDetailMain } from "./BankOpeningBalancesDetailMain";
import { BankOpeningBalancesDetailLines } from "./BankOpeningBalancesDetailLines";
import { BankOpeningBalancesDetailFooter } from "./BankOpeningBalancesDetailFooter";
import { useFetchBankOpeningBalances } from "../hooks/fetchDocument";

interface IProps {
  id?: string;
}

export const BankOpeningBalancesDetail = ({ id }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<BankOpeningBalancesModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;

  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Bank Opening Balances");

  useEffect(() => {
    // console.log("formState errors");
    if (Object.keys(formState.errors).length != 0) {
      console.log("formState.errors", formState);
      toast.error("Please fill required fields");
    }
  }, [formState]);

  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchBankOpeningBalances({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };
  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.BankOpeningBalances.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFSecondTab title={"Main"} />
        <NFSecondTab title={"Money"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar> */}
        
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handlePost} />
          <DetailViewCancelButton onCancel={handleCancel} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <BankOpeningBalancesDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <BankOpeningBalancesDetailLines />
        </NFTabContainer>
      </div>
      <BankOpeningBalancesDetailFooter />
    </FormProvider>
  );
};
